import { createSelector } from 'reselect'

const oeqActivitySelector = state => state.creationTool.oeq

const oeqValidationSelector = createSelector(
	[
		oeqActivitySelector,
	],
	oeqState => oeqState.question.text.trim() !== ''
)

export default oeqValidationSelector
